import { render, staticRenderFns } from "./Boats.vue?vue&type=template&id=76da899a&"
import script from "./Boats.vue?vue&type=script&lang=js&"
export * from "./Boats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Boats.vue"
export default component.exports